module.exports = __webpack_public_path__ + "static/iPhones-livre-0f34387330b6bed9369fa22bc7b677b4.jpg";